import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React, { FC, useEffect, useState } from 'react';

import { RootState, useDispatch, useSelector } from 'src/store';
import { pagesReset } from 'src/store/modules/pages';
import CloseIcon from '@material-ui/icons/Close';

import { editTextReset } from 'src/store/modules/editText';
import { buttonsReset } from 'src/store/modules/buttons';
import { imageReset } from 'src/store/modules/imageUpload';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';
import setInitValue from 'src/utils/setInitValue';
import { editUserCompany } from 'src/store/modules/client';
import { customlogReset } from 'src/store/modules/customlog';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import { initTrackingValues } from '../TemplateTracking/ChoiceButtonModalTracking';

const initViewValues = {
  bgOpacity: { bgDimmed: 70 },
  bgImage: {
    background: 'https://image.inappmessage.com/sample/defaultIMAGE.webp'
  },
  radius: { background: 14 },
  deeplink: {
    image_left_button: 'https://www.inappmessage.com/',
    image_right_button: 'https://www.inappmessage.com/',
    image_button: 'https://www.inappmessage.com/'
  },

  btnText: {
    image_left_button: 'GOOD',
    image_right_button: 'BAD',
    bottom_left_button: "Don't show again",
    bottom_right_button: 'Close',
    image_button: 'SOSO'
  },
  btnBgColorR: {
    image_left_button: 235,
    image_right_button: 87,
    bottom_left_button: 0,
    bottom_right_button: 0,
    image_button: 146
  },
  btnBgColorG: {
    image_left_button: 0,
    image_right_button: 0,
    bottom_left_button: 0,
    bottom_right_button: 0,
    image_button: 0
  },
  btnBgColorB: {
    image_left_button: 255,
    image_right_button: 255,
    bottom_left_button: 0,
    bottom_right_button: 0,
    image_button: 190
  },
  btnBgColorA: {
    image_left_button: 1,
    image_right_button: 1,
    bottom_left_button: 0,
    bottom_right_button: 0,
    image_button: 1
  },
  btnFontSize: {
    image_left_button: 0.9375,
    image_right_button: 0.9375,
    bottom_left_button: 0.875,
    bottom_right_button: 0.875,
    image_button: 0.9375
  },
  btnFontWeight: {
    image_left_button: 700,
    image_right_button: 700,
    bottom_left_button: 400,
    bottom_right_button: 400,
    image_button: 700
  },
  btnColor: {
    image_left_button: '#ffffff',
    image_right_button: '#ffffff',
    bottom_left_button: '#ffffff',
    bottom_right_button: '#ffffff',
    image_button: '#ffffff'
  },
  btnFontFamily: {
    image_left_button: 'Inter',
    image_right_button: 'Inter',
    bottom_left_button: 'Inter',
    bottom_right_button: 'Inter',
    image_button: 'Inter'
  },
  btnAgain: {
    type: 'attribute',
    bottom_left_button: 'opt-in'
  },
  button1: {
    image_left_button: [],
    image_right_button: [],
    image_button: [],
    bottom_left_button: [],
    bottom_right_button: []
  },
  button2: {
    image_left_button: [],
    image_right_button: [],
    image_button: [],
    bottom_left_button: [],
    bottom_right_button: []
  },
  btnType: 'single'
};

const ChoiceButtonModal: FC = () => {
  const dispatch = useDispatch();

  const templateWidth = useSelector(
    (state: any) => state.template.templateWidth
  );
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const btnType = useSelector((state: RootState) => state.buttons.btnType);

  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const imageButtonLeftFontURL = getFontURL(btnFontFamily?.image_left_button);
  const imageButtonRightFontURL = getFontURL(btnFontFamily?.image_right_button);
  const bottomLeftFontURL = getFontURL(btnFontFamily?.bottom_left_button);
  const bottomRightFontURL = getFontURL(btnFontFamily?.bottom_right_button);
  const imageButtonFontURL = getFontURL(btnFontFamily?.image_button);

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);
  // 커스텀 폰트 추가해야함 변경!
  const style = `
  @Font-face {
    font-family: 'imageLeftButton';
    src: url(${imageButtonLeftFontURL});
  }
  @Font-face {
    font-family: 'imageRightButton';
    src: url(${imageButtonRightFontURL});
  }
  @Font-face {
    font-family: 'bottomLeftButton';
    src: url(${bottomLeftFontURL});
  }
  @Font-face {
    font-family: 'bottomRightButton';
    src: url(${bottomRightFontURL});
  }
  @Font-face {
    font-family: 'imageButton';
    src: url(${imageButtonFontURL});
  }
  .root_view {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
  }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }
    
    .modal_wrapper {
      width: 100%;      
      padding: 18px;

      display: flex;
      flex-direction: column;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      border-radius: ${radius?.background}px;      
    }

    .image_wrapper {
      width: 100%;      
      height: 100%;      
      position: relative;
      outline: none;          
      overflow: hidden;
      margin-bottom: -5px;   
    }
    .image_wrapper img {
      width: 100%; 
      height: 100%;
      object-fit: cover;
      outline: none;
      border-radius: ${radius?.background}px;      
    }
    .image_btn_wrapper {
      position: absolute;
      width: 100%;
      bottom: 20px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;                
    }
    .image_btn_wrapper button {
      border: 0;
      border-radius: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;                  
    }
    .image_btn_wrapper .image_btn_left {
      width: 145px;
      height: 46px;
      padding: 0 16px;
      background-color:rgba(${btnBgColorR?.image_left_button},${
    btnBgColorG?.image_left_button
  }, ${btnBgColorB?.image_left_button}, ${
    btnBgColorA?.image_left_button
  });        
      color: ${btnColor?.image_left_button};
      font-size: ${btnFontSize?.image_left_button}rem;
      font-weight: ${btnFontWeight?.image_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.image_left_button
        )
          ? btnFontFamily?.image_left_button
          : 'imageLeftButton'
      };
    }

    .image_btn_wrapper .image_btn_right {
      width: 145px;
      height: 46px;
      padding: 0 16px;      
      background-color:rgba(${btnBgColorR?.image_right_button},${
    btnBgColorG?.image_right_button
  }, ${btnBgColorB?.image_right_button}, ${
    btnBgColorA?.image_right_button
  });        
      color: ${btnColor?.image_right_button};
      font-size: ${btnFontSize?.image_right_button}rem;
      font-weight: ${btnFontWeight?.image_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.image_right_button
        )
          ? btnFontFamily?.image_right_button
          : 'imageRightButton'
      };
    }
    .image_btn_wrapper .image_btn {
      width: 299px;
      height: 46px;
      padding: 0 16px;  
      background-color:rgba(${btnBgColorR?.image_button},${
    btnBgColorG?.image_button
  }, ${btnBgColorB?.image_button}, ${btnBgColorA?.image_button});            
      color: ${btnColor?.image_button};
      font-size: ${btnFontSize?.image_button}rem;
      font-weight: ${btnFontWeight?.image_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.image_button
        )
          ? btnFontFamily?.image_button
          : 'imageButton'
      };
    }

    .btn_wrapper {
      margin-top: 11px;
      padding: 0rem 0rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .btn_wrapper button {
      border: 0;
      background-color: transparent;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.bottom_left_button}rem;
      font-weight: ${btnFontWeight?.bottom_left_button};
      color: ${btnColor?.bottom_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_left_button
        )
          ? btnFontFamily?.bottom_left_button
          : 'bottomLeftButton'
      };
      padding-left: 0.5rem;
      text-align: left;
      background-color:rgba(${btnBgColorR?.bottom_left_button},${
    btnBgColorG?.bottom_left_button
  }, ${btnBgColorB?.bottom_left_button}, ${btnBgColorA?.bottom_left_button});
    }
    .btn_wrapper .style02 {
      display:flex;
      justify-content: flex-end;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.bottom_right_button}rem;
      font-weight: ${btnFontWeight?.bottom_right_button};
      color: ${btnColor?.bottom_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_right_button
        )
          ? btnFontFamily?.bottom_right_button
          : 'bottomRightButton'
      };

      text-align: right;
      background-color:rgba(${btnBgColorR?.bottom_right_button},${
    btnBgColorG?.bottom_right_button
  }, ${btnBgColorB?.bottom_right_button}, ${btnBgColorA?.bottom_right_button});
    }
    /*
     ${
       templateWidth > 767
         ? `
          .modal_wrapper {
            width: 50%;
            margin: 0 25%;
          }

          .close_btn {
            right: 25%;
            top: 4rem;
          }

          .contents_wrapper {
            padding: 0 2rem;
            margin: 3rem 0 2rem 0;
          }
          .contents_box .title {
            font-size: ${fontSize?.multi_title + 0.25}rem;
          }
          .slick_page {
            bottom: 5rem;
          }

          .btn_wrapper {
            height: 4rem;
            padding: 0.5rem 2rem;
            font
          }
          .btn_wrapper .style01 {
            font-size: ${btnFontSize?.multi_left_button + 0.25}rem;
          }
          .btn_wrapper .style02 {
            font-size: ${btnFontSize?.multi_right_button + 0.25}rem;
          }
        `
         : ''
     }
    */
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view">
        <div className="background" />
        <div className="modal_wrapper">
          <div className="image_wrapper">
            <img src={bgImage?.background} alt="insert_image" />
            <div className="image_btn_wrapper">
              {btnType && btnType === 'single' ? (
                <>
                  <button className="image_btn">{btnText?.image_button}</button>
                </>
              ) : (
                <>
                  <button className="image_btn_left">
                    {btnText?.image_left_button}
                  </button>
                  <button className="image_btn_right">
                    {btnText?.image_right_button}
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="btn_wrapper">
            <button className="style01">{btnText?.bottom_left_button}</button>
            <button className="style02">
              {btnText?.bottom_right_button}
              <CloseIcon
                style={{
                  fontSize: `${btnFontSize?.bottom_right_button + 0.25}rem`,
                  color: `${btnColor?.bottom_right_button}`
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChoiceButtonModal;
